import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { IUsr0103MState, IUserItemState, IUserListItemState, IInquiryCndsState, IUserStCdState, IDeptCdState } from '../../models/usr/usr0103m_model';
  
const initialState: IUsr0103MState = {
    userDatas: [],          // 사용자목록(조회결과)
    userList: [],           // 사용자정보 
    deptCdList: [],         // 부서코드 
    userStCdList: [],       // 사용자상태코드 

    inquiryCnds: {
        empNo    : '',      // 사원번호
        deptCd   : '',      // 부서코드
        userStCd : '',      // 사용자상태코드
    },                      // 조회조건

    pageSize : 20,          // 페이징사이즈
    current  : 0,           // 현재페이지
}

export const usr0103m_Slice = createSlice({
    name: "usr0103m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState
                                   , userStCdList: state.userStCdList
                                   , deptCdList: state.deptCdList
                                   , userList: state.userList});
        },
        setUserDatas: (state, action:PayloadAction<IUserListItemState[]>) => {
            state.userDatas = action.payload;
        },
        setUserList: (state, action:PayloadAction<IUserItemState[]>) => {
            state.userList = action.payload;
        },
        setUserStCdList: (state, action:PayloadAction<IUserStCdState[]>) => {
            state.userStCdList = action.payload;
        },
        setDeptCdList: (state, action:PayloadAction<IDeptCdState[]>) => {
            state.deptCdList = action.payload;
        },
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setPageSize: (state, action:PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setCurrent: (state, action:PayloadAction<number>) => {
            state.current = action.payload;
        },
    },
});

export default usr0103m_Slice.reducer;
export const Usr0103mAction  = usr0103m_Slice.actions;
export const Usr0103mReducer = usr0103m_Slice.reducer;